import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { createSelector } from "reselect";
import { fetchItemById } from "slices/item/thunk";
import { toast } from "react-toastify";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import CancelBackButton from "components/Buttons/CancelBackButton";
import LoadingSpinner from "components/LoaderErrorWrapper/LoadingSpinner";
import PageContainer from "components/PageContainer/PageContainer";

const ItemDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  // Redux selector for item state
  const selectItemData = createSelector(
    (state: any) => state.ItemReducer || state.item,
    (item) => ({
      selectedItem: item.selectedItem,
      loading: item.loading,
      error: item.error,
    })
  );

  const { selectedItem, loading, error } = useSelector(selectItemData);

  // Fetch item data using Redux thunk
  useEffect(() => {
    if (!id) {
      toast.error("Item ID is missing");
      navigate("/item");
      return;
    }

    // Dispatch thunk to fetch item by ID
    dispatch(fetchItemById(id));
  }, [id, dispatch, navigate]);

  // Handle errors
  useEffect(() => {
    if (error) {
      toast.error(error);
      navigate("/item");
    }
  }, [error, navigate]);

  const handleCancel = () => {
    navigate("/item");
  };

  const itemData = selectedItem;

  return (
    <PageContainer>
      <FormHeader
        title="Item"
        firstLabel="Item"
        secondLabel="Item Details"
        handleArrowClick={handleCancel}
        handleBreadcrumbClick={handleCancel}
      />

      {loading ? (
        <LoadingSpinner />
      ) : !selectedItem ? (
        <div className="text-center py-5">
          <p>No item data found</p>
          <CancelBackButton to="/item" label="Back to Item List" />
        </div>
      ) : (
        <>
          <hr />

      {/* Item Details */}
      <Row className="mb-3">
        <p>
          <h6 className="card-title mb-0 mt-3">Item Details</h6>
        </p>
        <Col md={6}>
          <p>
            <strong>Item Name :</strong>&nbsp;
            {itemData?.item_name || "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>Alternate Name :</strong>&nbsp;
            {itemData?.alternate_name || "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>Item Code :</strong>&nbsp;
            {itemData?.item_code || "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>Color :</strong>&nbsp;
            {itemData?.color || "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>Category :</strong>&nbsp;
            {itemData?.category?.category_name || "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>Sub Category :</strong>&nbsp;
            {itemData?.sub_category?.sub_category_name || "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>Unit :</strong>&nbsp;
            {itemData?.unit?.unit_name || "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>HSN Code :</strong>&nbsp;
            {itemData?.hsn_code?.hsn_code || "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>GST Percentage :</strong>&nbsp;
            {itemData?.hsn_code?.gst_percent?.gst_percent
              ? `${itemData.hsn_code.gst_percent.gst_percent}%`
              : "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>Selling Price :</strong>&nbsp;
            {itemData?.selling_price ? `₹${itemData.selling_price}` : "—"}
          </p>
        </Col>
        <Col md={6}>
          <p>
            <strong>Status :</strong>&nbsp;
            <span
              className={`badge ${
                itemData?.is_active ? "bg-success" : "bg-danger"
              }`}
            >
              {itemData?.is_active ? "Active" : "Inactive"}
            </span>
          </p>
        </Col>
        <Col md={12}>
          <p>
            <strong>Remarks :</strong>&nbsp;
            {itemData?.remark || "—"}
          </p>
        </Col>
      </Row>

          <div className="d-flex flex-wrap justify-content-center gap-3 mt-5">
            <CancelBackButton to="/item" label="Back" />
          </div>
        </>
      )}
    </PageContainer>
  );
};

export default ItemDetailsPage;

